import { render, staticRenderFns } from "./supervisors.vue?vue&type=template&id=79c8d058&scoped=true&"
import script from "./supervisors.vue?vue&type=script&lang=js&"
export * from "./supervisors.vue?vue&type=script&lang=js&"
import style0 from "./supervisors.vue?vue&type=style&index=0&id=79c8d058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8d058",
  null
  
)

export default component.exports